<p-toast></p-toast>
<div class="ui-g">
    <div class="ui-g-12" style="text-align-last: right;">
        <p-button type="button" (click)="addToFeatured(true)" label="Make Featured" [disabled]="loading"
            styleClass="p-button-text"></p-button>
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
        <p-button type="button" (click)="addToFeatured(false)" label="Make non Featured" [disabled]="loading"
            styleClass="p-button-text"></p-button>
    </div>
    <!-- <br><br> -->
    <div class="ui-g-12">
        <p-table #dt1 [value]="feedbacksData" [scrollable]="true" dataKey="id" styleClass="p-datatable-sm"
            [rows]="body.records_per_page" [loading]="loading" [autoLayout]="true" [lazy]="true"
            currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
            (onLazyLoad)="getFeedbacks($event)" [showCurrentPageReport]="true" [paginator]="true"
            [totalRecords]="total_records" [rowsPerPageOptions]="no_of_rows">

            <ng-template pTemplate="header">
                <tr>
                    <th style="text-align: center;" pSortableColumn="serial">
                        <b>Sr.No</b>
                    </th>
                    <th style="text-align: center;" pSortableColumn="user_name">
                        <b>User's Name</b>
                    </th>
                    <th style="text-align: center;" pSortableColumn="rating">
                        <b>Rating</b>
                    </th>
                    <th style="text-align: center;" pSortableColumn="country">
                        <b>Country</b>
                    </th>
                    <th style="text-align: center;" pSortableColumn="consented">
                        <b>Consented</b>
                    </th>
                    <th style="text-align: center;" pSortableColumn="featured">
                        <b>Featured </b>
                    </th>
                    <th style="text-align: center;" pSortableColumn="edit_feedback">
                        <b>Edit</b>
                    </th>
                    <th style="text-align: center;" pSortableColumn="show_details">
                        <b>Show Details</b>
                    </th>
                </tr>
            </ng-template>
            <ng-template pTemplate="body" let-feedback>
                <tr>
                    <td style=" text-align: center;">
                        {{feedback.sr_no}}
                    </td>

                    <td style="text-align: center;">
                        {{feedback.name}}
                    </td>
                    <td style="text-align: center;">
                        <!-- {{feedback.rating}} -->
                        <p-rating [ngModel]="feedback.rating" readonly="true" stars="5" [cancel]="false"></p-rating>
                    </td>
                    <td style="text-align: center;" class="notranslate">
                        {{feedback.country.country_name}}
                    </td>
                    <td style="text-align: center;">
                        {{feedback.has_consented ? 'Yes' : 'No'}}
                    </td>
                    <td style="text-align: center;">
                        {{feedback.is_featured ? 'Yes' : 'No'}}
                    </td>
                    <td style="text-align: center;">
                        <p-checkbox *ngIf="feedback.has_consented" [(ngModel)]="feedback.selected" [disabled]="loading"
                            [binary]="true">
                        </p-checkbox>
                    </td>
                    <td style="text-align: center;">
                        <p-button type="button" icon="pi pi-external-link" (click)="ViewFull(feedback.id)"
                            styleClass="p-button-text" label="Open"></p-button>
                    </td>
                </tr>
            </ng-template>
        </p-table>
        <div class="row container justify-content-center text-center alert alert-danger"
            *ngIf="this.table_response.success!=null && this.table_response.success==false">
            <p *ngIf="this.table_response.error!=null">{{this.table_response.error.message}}</p>
            <div *ngIf="this.table_serverError?.error!=null && this.table_serverError?.statusCode!=500">
                <p *ngFor="let message of this.table_serverError?.message">{{message}}</p>
            </div>
            <div *ngIf="this.table_serverError?.error!=null && this.table_serverError?.statusCode==500">
                <p>{{this.table_serverError?.message}}</p>
            </div>
        </div>
        <p-dialog header="Feedback Details" *ngIf="fullFeedbackDialog" (onHide)="fullFeedbackDialog=false"
            [(visible)]="fullFeedbackDialog" [style]="{width: '50vw'}" [baseZIndex]="10000">
            <p class="custon_rating"><b>Name: </b> {{currentFeedback.name}}</p>
            <br>
            <p class="custon_rating" class="notranslate"><b>Country: </b>{{currentFeedback.country.country_name}}</p>
            <br>
            <p class="custon_rating"><b>Email: </b> {{currentFeedback.email}}</p>
            <br>
            <p class="custon_rating"><b>Rating: </b>
                <p-rating [ngModel]="currentFeedback.rating" readonly="true" stars="5" [cancel]="false"></p-rating>
            </p>
            <br>
            <p class="custon_rating"><b>Message: </b> </p>
            <div>{{currentFeedback.message}}</div>
            <br>
            <p class="custon_rating"><b>Source: </b> {{currentFeedback.source | titlecase}}</p>
            <br>
            <p class="custon_rating"><b>Consented: </b> {{currentFeedback.has_consented?"Yes":"No"}}</p>
            <br>
            <p class="custon_rating"><b>Featured on Homepage?: </b> {{currentFeedback.is_featured?"Yes":"No"}}</p>
            <br>
            <p class="custon_rating"><b>Submitted on: </b> {{currentFeedback.created_at | date:'medium'}}</p>
            <br>
        </p-dialog>
    </div>
</div>